module.exports = __webpack_public_path__ + "assets/img/rubikon-k2.a0194c5e.png";